export var getClassName = function getClassName(baseClassName, extendedName, defaultClass) {
  var className = defaultClass || '';

  if (baseClassName) {
    className = baseClassName;

    if (extendedName) {
      className = "".concat(className, "-").concat(extendedName);
    }

    if (defaultClass) {
      className = "".concat(className, " ").concat(defaultClass);
    }
  }

  return className;
};